import React, { useState, useEffect, useRef } from 'react';
import { components } from 'react-select';

import { useField } from '@unform/core';

import SelectType from './select_type';
import {
  Label,
  ErrorMessage,
  ReactSelectCustom,
  CircleProgressCustom,
} from './style';

// Este componente encapsula a biblioteca React-Select (https://react-select.com/)
// Muitas opcoes nao estao sendo usadas. Caso seja necessario utilizar uma funcionalidade nova,
// ver a documentacao em https://react-select.com/props#api

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <CircleProgressCustom size={15} />
    </components.DropdownIndicator>
  );
};

const Input = (dataTest?: string) => (props: any) => (
  <components.Input data-testid={dataTest} {...props} />
);

interface SelectProps {
  name: string;
  label?: string;
  width?: string;
  options: SelectType[];
  loading?: boolean;
  initialValues?: any;
  placeholder: string;
  isMulti?: boolean;
  onChange: (value: any) => void;
  value?: SelectType[];
  required?: any;
  'data-testid'?: string;
  [propType: string]: any;
}

export const Select: React.FC<SelectProps> = (props: SelectProps) => {
  const {
    name,
    label,
    width,
    loading,
    options,
    isMulti = true,
    placeholder,
    isDisabled,
    initialValues,
    onChange,
    ...rest
  } = props;
  const selectRef = useRef<any>();

  const customComponents: any = loading
    ? {
        DropdownIndicator,
      }
    : {};
  customComponents.Input = Input(props['data-testid']);

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (!ref.state.value) {
          return '';
        }
        return ref.state.value.value;
      },
    });
  }, [fieldName, registerField]);

  const [values, setValue] = useState<any>(initialValues);

  const customStyles = {
    control: (styles: any | null) => ({
      ...styles,
      width: 'auto',
      height: 'auto',
      padding: 8,
      boxShadow: 'none',
    }),
    multiValue: (styles: any | null) => ({
      ...styles,
      color: '#555',
      fontSize: 18,
    }),
    multiValueRemove: (styles: any | null) => ({
      ...styles,
      color: '#ffffff',
    }),
  };

  function handleChange(selectedOptions: any | null) {
    let options: any = [];
    if (selectedOptions) {
      options = selectedOptions;
    }

    if (isMulti) {
      setValue(
        options.map((el: any) => {
          return el.value;
        }),
      );
    } else {
      setValue(options.value);
    }
    onChange(options);
  }

  return (
    <div style={{ width: width }}>
      <Label>{label}</Label>
      <ReactSelectCustom
        {...rest}
        id={label}
        isDisabled={loading || isDisabled}
        ref={selectRef}
        name={fieldName}
        defaultValue={defaultValue}
        classNamePrefix="react-select"
        hasError={error}
        closeMenuOnSelect={false}
        isMulti={isMulti}
        options={options}
        value={options.filter((option: SelectType) => {
          return isMulti
            ? values && values.includes(option.value)
            : values === option.value;
        })}
        onChange={handleChange}
        onFocus={clearError}
        styles={customStyles}
        placeholder={loading ? 'Carregando...' : placeholder}
        noOptionsMessage={() => 'Sem opções para exibir'}
        isSearchable={false}
        components={customComponents}
      />
      <ErrorMessage hasError={!!error}>
        <div>{error}</div>
      </ErrorMessage>
    </div>
  );
};
